import React, { useRef } from "react";
import Defs from "./assets/Defs";
import Pickup from "./assets/Pickup";
import SpoolBacks from "./assets/SpoolBacks";
import Spools from "./assets/Spools";
import TapeWheels from "./assets/TapeWheels";
import VolumeMeter from "./assets/VolumeMeter";
import styles from "./reelToReel.module.css";
import Tape from "./assets/Tape";
// import EyeBall from "../eyeBall/EyeBall";
// import { useWindowSize } from "../../hooks/useWindowSize";

export default function ReelToReel({
  totalSeconds = 0,
  progress,
  timings,
  ampVals,
}) {
  // const [svgBounds, setSvgBounds] = useState(null);
  const svgRef = useRef(null);
  // const size = useWindowSize();

  const secondsPerRotation = 5;
  const totalRotations = totalSeconds / secondsPerRotation;

  const isTransparent = false;

  // useEffect(() => {
  //   if (svgRef && svgRef.current && size.width) {
  //     let bounds = svgRef.current.getBoundingClientRect();
  //     setSvgBounds(bounds);
  //   }
  // }, [svgRef, size]);

  return (
    <div className={styles.tapePlayerHolder}>
      <svg
        viewBox="0 0 229 165"
        width="100%"
        className={styles.svg}
        ref={svgRef}
      >
        <Defs isTransparent={isTransparent} />

        <Tape
          progress={progress}
          timings={timings}
          isTransparent={isTransparent}
        />

        <g transform={`scale(1.3) translate(-26, -32)`}>
          <Pickup
            progress={progress}
            timings={timings}
            isTransparent={isTransparent}
          />
        </g>

        <g transform={`scale(2) translate(-57, -55)`}>
          <VolumeMeter
            ampVals={ampVals}
            progress={progress}
            timings={timings}
            isTransparent={isTransparent}
          />
        </g>

        <SpoolBacks
          progress={progress}
          timings={timings}
          isTransparent={isTransparent}
        />

        <TapeWheels
          progress={progress}
          timings={timings}
          totalSpoolRotations={totalRotations}
          isTransparent={isTransparent}
        />

        <Spools
          progress={progress}
          timings={timings}
          totalRotations={totalRotations}
          isTransparent={isTransparent}
        />

        {/* <EyeBall svgBounds={svgBounds} /> */}
      </svg>
    </div>
  );
}
